var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { C } from '#integrations';
import { Box } from '../Box';
import { InlineImage } from '../InlineImage';
import loadingLogoAnimation from '../../assets/illustrations/loading-animation-neon.asset.gif';
import styles from './LoadingBox.module.css';
export const LoadingBox = ({ alt, children, className, 'data-testid': testId, gap = 'm', isCoverPage, isFullHeight = false, isFullWidth = false, justify = 'center', }) => {
    return (_jsxs(Box, { align: "center", className: C(styles.Container, isCoverPage && styles.CoverPage, className), gap: gap, isFullHeight: isFullHeight, isFullWidth: isFullWidth, justify: justify, orientation: "vertical", children: [_jsx(InlineImage, { alt: alt, "data-testid": testId, height: "76px", src: loadingLogoAnimation, width: "76px" }), children] }));
};
_react_refresh_temp_1 = LoadingBox;
$RefreshReg$(_react_refresh_temp_1, "LoadingBox");
